import {React, useState, useEffect} from 'react'
import Header from '../../component/Header'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {orderBy, db,  collection, query, where, getDocs, deleteDoc, doc } from '../../firebase/index';
import GroupCard from '../../component/GroupCard';
export default function Group() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groups, setGroups] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const fetchGroups = async () => {
    setGroups([])
    const q = query(collection(db, "groupClass"),orderBy('name'));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const data = {
        id: doc.id,
        ...doc.data()
      }
      setGroups((groups) => [...groups, data]);
    });
  }
  const deleteRecord = async (id) => {
    try {
      await deleteDoc(doc(db, "groupAttendance", id));
      setAttendance(currentAttendance => 
        currentAttendance.filter(record => record.id !== id)
      );
      alert("Document successfully deleted!");
    } catch (error) {
      alert("Error removing document: ", error);
    }
  };

  const fetchAttendance = async () => {
    setAttendance([])
    const formattedStartDate = startDate.toISOString().slice(0, 10);
    const formattedEndDate = endDate.toISOString().slice(0, 10);
    const q = query(collection(db, "groupAttendance") ,orderBy("date"), where("courseName", "==", selectedGroup), where('date', '<=',  formattedEndDate) , where('date', '>=', formattedStartDate));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const data = {
        id: doc.id,
        ...doc.data()
      }
      console.log(data)
      setAttendance((attendance) => [...attendance, data]);
    });
  }

  useEffect(()=>{
    fetchGroups();
  }, [])

  return (
    <div>
      <Header/>
      <div className="p-10 bg-gray-100">
          <h1 className="text-blue-800 text-4xl font-bold">
            GroupAttendance
          </h1>
      </div>
      <div className='flex flex-wrap justify-around px-20 py-5 bg-gray-100 '>
        <div>
            <div className="mb-2">
              Start Date: 
            </div>
            <div>
              <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
            </div>
        </div>
        <div>
          <div className="mb-2">
            End Date:
          </div>
          <div>
            <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} />
          </div>
        </div>
        <div>
          <div className="max-w-sm mx-auto">
            <label for="countries" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Group: </label>
            <select onChange={(e)=>{setSelectedGroup(e.target.value)}} id="countries" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <option selected>Group</option>
              {groups.map((g, index)=>{
                return(
                  <option key={index} value={g.name}>{g.name}</option>
                )
              })}
            </select>
          </div>

        </div>
      </div>
      <div class="flex justify-center items-center h-12 bg-gray-100 py-10">
        <button onClick={()=>{fetchAttendance()}} class="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 rounded-lg text-xl px-5 py-2.5 text-center">
          Fetch
        </button>
      </div>
      <div className='flex flex-wrap justify-around gap-1 py-10 bg-black px-10'>
        {
          attendance.map((a, index) => {
            return (
              <div key={index} className='w-full lg:w-1/3 xl:w-1/4'>
                <GroupCard data={a} 
                deleteRecord={ deleteRecord }/>
              </div>
            );
          })
        }
      </div>

    </div>

  );
}
